module.exports = __webpack_public_path__ + "3eab4106372136131aa34fe4ca3be6ab.png";